__webpack_require__.p = "https://assets.worldcubeassociation.org/assets/aaf3fff/packs/";